export default process.env.NODE_ENV === 'production' ? 'https://lifturi-s6.verdedata.ro' : 'http://localhost:5555'
// export default process.env.NODE_ENV === 'production' ? 'https://lifturi-s6.dragos.club' : 'http://localhost:6555'
